import ToggleSwitchStyles from "./ToggleSwitch.module.css";

type ToggleProps = {
  setToggleState: (prev: (prevState: boolean) => boolean) => void;
  toggleState: boolean;
  addOns?: any;
  disable?: boolean;
  label?: string;
  id?: string;
};

const ToggleSwitch: React.FC<ToggleProps> = ({
  toggleState,
  setToggleState,
  addOns,
  disable = false,
  label = "Toggle",
  id,
}) => {
  const isDisabled = disable;

  const handleToggle = () => {
    if (isDisabled) return;
    setToggleState((previous) => !previous);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (isDisabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setToggleState((previous) => !previous);
    }
  };

  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={toggleState}
      aria-label={label}
      disabled={isDisabled}
      className={`${ToggleSwitchStyles.toggleContainer} ${
        toggleState ? ToggleSwitchStyles.on : ToggleSwitchStyles.off
      } ${isDisabled ? ToggleSwitchStyles.disabled : ""}`}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
    >
      <span className={ToggleSwitchStyles.toggleCircle} aria-hidden="true" />
    </button>
  );
};

export default ToggleSwitch;
